import { MODULES } from '@core/constants/modules.contants';
import { ROUTER } from '@core/constants/router.constants';
import { useService } from '@policoders/di';
import Layout from '@shared/components/layout.component';
import { NavbarItem } from '@shared/components/navbar/navbar-item.model';
import NavbarService from '@shared/components/navbar/navbar.service';
import { Outlet } from 'react-router-dom';

const ChangemanLayout: React.FC = () => {
  const items: NavbarItem[] = [{ label: 'Início', to: ROUTER.CHANGEMAN.INDEX, type: 'nav-item' }];
  const navbar = useService<NavbarService>('NavbarService');
  navbar.set({ module: MODULES.CHANGEMAN, navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ChangemanLayout;
